export default "__VITE_ASSET__Qjm825A$__"